import { useEffect, useState } from 'react';

/**
 * Schedules a delayed value update and returns a cancel function.
 * Extracted for unit testing of debounce timing without a DOM.
 */
export function scheduleDebouncedUpdate<T>(
  value: T,
  delayMs: number,
  onUpdate: (nextValue: T) => void,
  setTimeoutFn: typeof setTimeout = setTimeout,
  clearTimeoutFn: typeof clearTimeout = clearTimeout,
): () => void {
  const timeoutId = setTimeoutFn(() => {
    onUpdate(value);
  }, delayMs);

  return () => {
    clearTimeoutFn(timeoutId);
  };
}

//Shared debounced value hook
export function useDebouncedValue<T>(value: T, delayMs = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    return scheduleDebouncedUpdate(value, delayMs, setDebouncedValue);
  }, [value, delayMs]);

  return debouncedValue;
}
